import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/bootstrap-vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import VueMoment from 'vue-moment';
import VueScrollTo from 'vue-scrollto';
import 'vue2-datepicker/locale/zh-tw';
import '@/plugins/validate/vee-validate';
import '@fortawesome/fontawesome-free/css/all.css';
import InfiniteLoading from 'vue-infinite-loading';

Vue.config.productionTip = false;

moment.locale('zh-tw');
Vue.use(VueMoment, { moment });
Vue.component('DatePicker', DatePicker);
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
Vue.use(InfiniteLoading);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
